import { LAYERS } from "common/sizes"
import styled from "styled-components"
import { HEADER_HEIGHT, HEADER_TITLE_HEIGHT } from "./global"
import { COLOR_PALETTE } from 'common/colors';

export const Title = styled.span`
    font-family: Rubik;
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #4f4f6f;
    white-space: nowrap;
`

export const Label = styled.span`
    display: flex;
    font-family: Rubik;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #000;
`

export const SectionTitle = styled.span`
    display: flex;
    font-family: Rubik;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #fefefe;
`

export const Header = styled.header`
    display: flex;
    width: 100%;
    flex: 0 1 auto;
    min-height: ${HEADER_HEIGHT};
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
    z-index: ${LAYERS.LAYER_6};
    background-color: ${COLOR_PALETTE.DARK_BLUE} ;
`

export const Button = styled.button`
    border: none;
    outline: none;
    cursor: pointer;
`;

export const ButtonAction = styled(Button)`
    display: flex;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: 1.7px;
    text-align: center;
    border-radius: 1px;
    align-items: center;
`;

export interface ButtonWrapperProps {
    margin?: string
    padding?: string
    justifyContent?: string
    minWidth?: string
    maxWidth?: string
    maxHeight?: string
}

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: ${(props: ButtonWrapperProps) => props.justifyContent ? props.justifyContent : 'center'};
    margin: ${(props: ButtonWrapperProps) => props.margin ? props.margin : ''};
    padding: ${(props: ButtonWrapperProps) => props.padding ? props.padding : ''};
    min-width: ${(props: ButtonWrapperProps) => props.minWidth ? props.minWidth : ''};
    max-width: ${(props: ButtonWrapperProps) => props.maxWidth ? props.maxWidth : ''};
    max-height: ${(props: ButtonWrapperProps) => props.maxHeight ? props.maxHeight : ''};
    
`;


export interface SectionWrapperProps {
    margin?: string
    padding?: string
    justifyContent?: string
    minWidth?: string
    maxWidth?: string
    maxHeight?: string
    flexFlow?: string
}

export const SectionWrapper = styled.div`
    display: flex;
    justify-content: ${(props: SectionWrapperProps) => props.justifyContent ? props.justifyContent : 'center'};
    margin: ${(props: SectionWrapperProps) => props.margin ? props.margin : ''};
    flex-flow: ${(props: SectionWrapperProps) => props.flexFlow ? props.flexFlow : ''};
    padding: ${(props: SectionWrapperProps) => props.padding ? props.padding : ''};
    min-width: ${(props: SectionWrapperProps) => props.minWidth ? props.minWidth : ''};
    max-width: ${(props: SectionWrapperProps) => props.maxWidth ? props.maxWidth : ''};
    max-height: ${(props: SectionWrapperProps) => props.maxHeight ? props.maxHeight : ''};
    
`;


export const InfoHeader = styled.div`
    display: flex;
    width: 100%;
    flex: 0 1 auto;
    max-height: 60px;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
    z-index: 100;
    background-color: ${COLOR_PALETTE.SNOWFLAKE};
    padding: 0px 26px;
    position: relative;
    height: 60px;
    align-items: center;
    justify-content: space-between;
`
export const PageTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  height:60px;
  min-height:60px;
  padding: 0px 0px 0px 26px;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  background-color: #fff;
  z-index: 200;
`

export const PageTitleText = styled.span`
  font-family: Lato;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4f4f6f;
  white-space: nowrap;
`

